import moment from 'moment';

// 获取近x个月日期
export const getMonthDate = (num = 3, fmt = 'YYYY-MM-DD') => {
  const startDate = moment().subtract(num, 'months').format(fmt); // 当前开始日期
  const endDate = moment().format(fmt); // 当前结束日期
  return {
    startDate,
    endDate,
  };
};
